import React from 'react';
import { TreeSelect } from 'antd';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import './customStyles.css';

const { SHOW_PARENT } = TreeSelect;

const MultiTreeSelect = ({ data, onChange, value, error, id }) => {
  const treeData = data;

  return (
    <div className="custom-tree-select-wrapper">
      <TreeSelect
        id={id}
        showSearch
        style={{
          width: '100%',
          borderRadius: '0px',
          border: error ? '1px solid red' : '1px solid black',
          minWidth: '400px',
        }}
        className="custom-tree-select"
        value={value}
        dropdownStyle={{
          maxHeight: 500,
          overflow: 'auto',
          border: 'none',
        }}
        allowClear
        multiple
        size="large"
        treeCheckable
        // treeCheckStrictly
        showCheckedStrategy={SHOW_PARENT}
        onChange={onChange}
        treeData={treeData}
      />
      <KeyboardArrowDownIcon
        className="custom-arrow"
        style={{ fontSize: '1.5rem', color: '#757575' }}
      />
    </div>
  );
};

export default MultiTreeSelect;
